<template>
  <div v-loading.fullscreen.lock="isLoading">
    <el-card>
      <div slot="header">
        <!-- <el-button style="padding: 3px 0" type="text" @click="back">
          <i class="el-icon-arrow-left"></i>
        </el-button> -->
        <el-row style="line-height: 40px">
          <el-col :span="4">
            <span style="font-size: 16px; font-weight: bold">
              使用者帳號管理
            </span>
          </el-col>

          <el-col :span="6" :offset="14">
            <el-button
              id="test_lifeClass_btAdd"
              style="float: right; margin-right: 10px"
              type="primary"
              @click="openDialog"
              >新增使用者</el-button
            >
          </el-col>
        </el-row>
      </div>

      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column
          prop="title"
          label="使用者名稱"
          width="180"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="username"
          label="帳號"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="role"
          label="角色"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-for="item in scope.row.role" :key="item.authority">
              {{ item.authority=='ROLE_ADMIN'?'系統管理員':item.authority=='ROLE_USER'?'使用者':item.authority=='ROLE_PERSON_ADMIN'?'人員資料管理員':'' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="openDialog(scope.row)"
              >編輯</el-button
            >
            <el-button type="danger" size="small" @click="deleteOne(scope.row)"
              >刪除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="使用者帳號" :visible.sync="dialogShow" width="40%" :destroy-on-close="true" >
      <userAdd
        :clickTime="dialogTime"
        :id="dialogId"
        @close="closeDialog"
      ></userAdd>
    </el-dialog>
  </div>
</template>

<script>
import API from "../../api";
import Utils from "../../utils";
import { InformType } from "@/utils/InformType";
import userAdd from "./component/userAdd";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "user",

  components: { userAdd },

  data() {
    return {
      isLoading: false,
      tableData: [],
      dialogShow: false,
      dialogTime: null,
      dialogId: NaN,
      addForm: {
        lifeName: "",
      },
      qString: "",
    };
  },

  created() {
    this.query();
  },

  methods: {
    query() {
      console.log("讀取");
      this.isLoading = true;
      API.user.query().then((res) => {
        // console.log(res.data);
        this.tableData = res.data;
        this.isLoading = false;
      });
    },
    openDialog(row) {
      this.dialogTime = new Date();
      this.dialogShow = true;
      this.dialogId = row ? row.id : NaN;
    },
    closeDialog() {
      this.dialogShow = false;
      this.query();
    },
    deleteOne(row) {
      if(row.username=='admin'){
        Utils.Message.send("無法刪除系統管理員!", InformType.ERROR);
        return;
      }
      
      this.$confirm("刪除無法還原！是否確定刪除帳號？", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
      }).then(() => {
        this.isLoading = true;
        if (row.id) {
          console.log("刪除");
          API.user
            .deleteOne(row.id)
            .then(() => {
              Utils.Message.send("刪除帳號成功!", InformType.SUCCESS);
              this.isLoading = false;
              this.query();
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },
    gotoImport() {
      this.$router.push({ name: "人員匯入" });
    },
  },
};
</script>

<style>
.darkblue {
  background-color: #527bae;
  color: #ffffff;
}
</style>